import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useAuth } from "@/hooks/useAuth";
import ListingForm from "./components/ListingForm";

const TIPS = [
  { icon: "ri-camera-3-line", title: "Shoot in daylight", text: "Clean the car and take photos in natural light from a few angles." },
  { icon: "ri-price-tag-3-line", title: "Price to the market", text: "Check similar cars nearby and set a competitive daily rate." },
  { icon: "ri-chat-smile-2-line", title: "Reply fast", text: "Quick replies and instant book get you more confirmed trips." },
];

export default function HostPage() {
  const { user, loading } = useAuth();

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />

      <div className="mx-auto w-full max-w-6xl px-4 pb-20 pt-28 md:px-8 md:pt-36">
        <div className="max-w-2xl">
          <span className="text-sm font-medium uppercase tracking-[0.2em] text-primary-500">List your car</span>
          <h1 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
            Turn your car into income
          </h1>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            Add your car to Gari in a few minutes. Set your price, choose your availability, and start earning in
            Kenyan Shillings.
          </p>
        </div>

        {loading ? (
          <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_320px]">
            <div className="h-96 w-full animate-pulse rounded-2xl bg-background-100" />
            <div className="h-64 w-full animate-pulse rounded-2xl bg-background-100" />
          </div>
        ) : !user ? (
          <div className="mt-10 flex flex-col items-center justify-center rounded-2xl border border-dashed border-background-200 bg-background-100 px-6 py-20 text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200/60 text-3xl text-foreground-500">
              <i className="ri-hand-coin-line"></i>
            </span>
            <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">Create a host account to list your car</h3>
            <p className="mt-2 max-w-md text-sm text-foreground-600">
              Sign in or sign up as a host, and you&apos;ll be able to publish your car and manage bookings from your
              dashboard.
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <Link
                to="/auth?redirect=/host"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-user-add-line"></i> Sign up to host
              </Link>
              <Link
                to="/auth?redirect=/host"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-5 py-2.5 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-500/60"
              >
                <i className="ri-login-circle-line"></i> Sign in
              </Link>
            </div>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_320px]">
            <ListingForm />

            <aside className="space-y-4 lg:sticky lg:top-28 lg:self-start">
              <div className="rounded-2xl border border-background-200/70 bg-background-100 p-5">
                <p className="flex items-center gap-2 text-sm font-medium text-foreground-950">
                  <i className="ri-lightbulb-line text-primary-500"></i> Hosting tips
                </p>
                <ul className="mt-4 space-y-4">
                  {TIPS.map((tip) => (
                    <li key={tip.title} className="flex items-start gap-3">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-500/12 text-lg text-primary-400">
                        <i className={tip.icon}></i>
                      </span>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{tip.title}</p>
                        <p className="mt-0.5 text-xs leading-relaxed text-foreground-500">{tip.text}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="rounded-2xl border border-accent-500/25 bg-accent-500/10 p-5">
                <p className="flex items-center gap-2 text-sm font-medium text-accent-300">
                  <i className="ri-shield-check-line"></i> Covered by Gari
                </p>
                <p className="mt-2 text-xs leading-relaxed text-foreground-700">
                  Every trip is backed by our protection plan and supports M-Pesa payouts straight to your phone.
                </p>
              </div>

              <Link
                to="/dashboard"
                className="flex items-center justify-between rounded-2xl border border-background-200/70 bg-background-100 px-5 py-4 text-sm font-medium text-foreground-900 transition-colors hover:border-primary-500/60"
              >
                Go to host dashboard
                <i className="ri-arrow-right-line text-primary-500"></i>
              </Link>
            </aside>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}